import BookingDialogStore from '@stores/DialogsStores/BookingDialogStore';

class CancelBookingDialogStore extends BookingDialogStore {
}

export default CancelBookingDialogStore;
